import { useMemo } from 'react'
import { getBrandingInfo, getTagline, getFullTitle } from '../utils/branding'
import { getCurrentDomain } from '../utils/domain'

export const useBranding = () => {
    const domain = getCurrentDomain()

    const branding = useMemo(() => {
        // Use the branding utility which already handles domain detection
        return getBrandingInfo()
    }, [domain])

    const getTaglineForCountry = (country: string) => {
        return getTagline(country)
    }

    const getFullTitleWithSite = (title: string) => {
        return getFullTitle(title)
    }

    return {
        ...branding,
        getTaglineForCountry,
        getFullTitleWithSite,
        domain
    }
} 